import { Component, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { AccountService } from '../services/account-service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent {
  @Output() public sidenavToggle = new EventEmitter();

  userName: string = "VennHealth User"

  constructor(private readonly accountService: AccountService) { }

  ngOnInit(): void {
    const account = this.accountService.accountValue;
    if (account) {
      this.userName = `${account.firstName} ${account.lastName}`;
    }
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  }
  
}
